import { InjectionToken } from '@angular/core';

export const OVERLAY_LEVEL = new InjectionToken<number>('overlayLevel', {
  providedIn: 'root',
  factory: () => 0,
});
